import { Link } from 'react-router';
import { categoryLabels } from '@/data/projects';
import type { Project } from '@/data/types';
import { useLang } from '@/hooks/useLang';
import { cn } from '@/lib/cn';

export function ProjectCard({ project, className }: { project: Project; className?: string }) {
  const lang = useLang();
  const title = lang === 'en' && project.titleEn ? project.titleEn : project.title;

  return (
    <Link to={`/lavori/${project.slug}`} className={cn('group block', className)}>
      <div className="relative aspect-4/5 overflow-hidden bg-paper-deep">
        <img
          src={project.cover}
          alt={title}
          loading="lazy"
          decoding="async"
          className="h-full w-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-ink/0 transition-colors duration-700 group-hover:bg-ink/10" />
      </div>
      <div className="mt-4 flex items-baseline justify-between gap-4">
        <h3 className="font-display text-xl md:text-2xl">{title}</h3>
        <span className="eyebrow shrink-0 text-stone">{project.year}</span>
      </div>
      <p className="mt-1 text-sm text-stone">
        {categoryLabels[project.category][lang]} · {project.location}
      </p>
    </Link>
  );
}
